import z from 'zod';
import { productEntityFields } from './product-fields';

export default {
  clicked: z.object({
    ...productEntityFields,
  }),
  viewed: z.object({
    ...productEntityFields,
  }),
  added: z.object({
    ...productEntityFields,
    cartId: z.string(),
  }),
  removed: z.object({
    ...productEntityFields,
    cartId: z.string(),
  }),
};
